export const Colors = {
    white: '#fff',
    black: '#000',
    primary: '#F18543',
    // primary: '#232242',
    secondary: '#F2B400',
    // your colors
}